import { createReducer } from '@reduxjs/toolkit';
import { SET_MODAL_SEARCH_BOX_IS_OPEN } from '../actions/SearchBoxAction';

const initialState = {
    modalSearchBoxIsOpen: false,
};

const searchBox = createReducer(initialState, (builder) => {
    builder
        .addCase(SET_MODAL_SEARCH_BOX_IS_OPEN, (state, action) => {
            state.modalSearchBoxIsOpen = action.isOpen;
        });
});

export default searchBox;
